import React, {useEffect, useRef, useState} from 'react'
import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import {accessToken} from "./../tokens";
import {hasHikedTrail, nationalParks} from "../utils/NationalParksUtils";
import bryceCanyon from "../images/big-bend.png"
import axios from "axios";
import {getBearerToken, getServerUrl} from "../utils/utils";


function NationalParksMapTwo({trips, selectedNationalPark, setSelectedNationalPark, hoveredHikingTrailBox, zoom, center, selectedNationalParkObj, setSelectedNationalParkObj}) {
    mapboxgl.accessToken = accessToken;
    const mapContainer = useRef(null);
    const map = useRef(null);
    const [parkMarkersObj, setParkMarkersObj] = useState({})
    const [previousHoveredHikingTrailBox, setPreviousHoveredHikingTrailBox] = useState(null)
    const [currentZoom, setCurrentZoom] = useState(4.2)

    const updateTrailsWhenHovered = (trail, isHovered, selectedNationalPark) => {
        if (selectedNationalPark?.trails) {
            const trails = JSON.parse(selectedNationalParkObj?.trails)
            trails.features.forEach(trailFeature => {
                if (trailFeature.properties.TRLNAME === trail.TRLNAME) {
                    if (isHovered) {
                        map.current.setPaintProperty(`${trailFeature.properties.OBJECTID}`, 'line-color', 'red');
                        map.current.setPaintProperty(`${trailFeature.properties.OBJECTID}`, 'line-width', 5);
                    } else {
                        map.current.setPaintProperty(`${trailFeature.properties.OBJECTID}`, 'line-color', "darkorange");
                        map.current.setPaintProperty(`${trailFeature.properties.OBJECTID}`, 'line-width', 3);
                    }
                }
            })
        }
    }

    useEffect(() => {
        if (hoveredHikingTrailBox && selectedNationalParkObj) {
            if (!previousHoveredHikingTrailBox) {
                setPreviousHoveredHikingTrailBox(hoveredHikingTrailBox)
            }
            if (previousHoveredHikingTrailBox?.OBJECTID !== hoveredHikingTrailBox?.OBJECTID) {
                if (previousHoveredHikingTrailBox) {
                    updateTrailsWhenHovered(previousHoveredHikingTrailBox, false, selectedNationalParkObj)
                    setPreviousHoveredHikingTrailBox(hoveredHikingTrailBox)
                }
            }
            updateTrailsWhenHovered(hoveredHikingTrailBox, true, selectedNationalParkObj)

        } else if (!hoveredHikingTrailBox && previousHoveredHikingTrailBox && selectedNationalParkObj) {
            updateTrailsWhenHovered(previousHoveredHikingTrailBox, false, selectedNationalParkObj)
        }
        {

        }
    }, [hoveredHikingTrailBox, previousHoveredHikingTrailBox, selectedNationalParkObj])

    function getArrayDepth(arr) {
        let maxDepth = 1; // Start with 1 for the initial array level

        // Iterate through each element of the array
        for (let i = 0; i < arr.length; i++) {
            // If the current element is an array, recursively call the function
            if (Array.isArray(arr[i])) {
                const currentElementDepth = 1 + getArrayDepth(arr[i]); // Add 1 for the current level
                maxDepth = Math.max(maxDepth, currentElementDepth); // Update maxDepth if current depth is greater
            }
        }
        return maxDepth;
    }

    const getZoom = nationalParkInfo => {
        // const nationalParkInfo = nationalParks.find(nationalPark => nationalPark.name === selectedLocation)
        const boundary = JSON.parse(nationalParkInfo.boundary)
        const arrayDepth = getArrayDepth(boundary?.features[0]?.geometry.coordinates)
        var coordinates = boundary?.features[0]?.geometry.coordinates.flat(arrayDepth - 2);
        if (coordinates) {
            var bounds = coordinates?.reduce(function (bounds, coord) {
                return bounds.extend(coord);
            }, new mapboxgl.LngLatBounds(coordinates[0], coordinates[0]));

            const latDifference = Math.abs(bounds._ne.lat - bounds._sw.lat)
            const lngDifference = Math.abs(bounds._ne.lng - bounds._sw.lng)

            bounds._ne = {
                lng: bounds._ne.lng,
                lat: bounds._ne.lat + latDifference * 0.15
            }
            bounds._sw = {
                lng: bounds._sw.lng - lngDifference,
                lat: bounds._sw.lat
            }

            map.current.fitBounds(bounds, {
                padding: 10
            });
        }

    }


    const addMarkerToLocation = (nationalPark, hasBeenVisited, index) => {
        fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/${nationalPark.name}.json?access_token=${accessToken}`)
            .then(response => response.json())
            .then(data => {
                if (data.features) {
                    const coordinates = {
                        lng: data.features[0].center[0],
                        lat: data.features[0].center[1]
                    }

                    var el = document.createElement('div');
                    el.className = `marker rankingMarker `;

                    el.className = `marker rankingMarker ${hasBeenVisited ? "" : "park-not-visited"}`;
                    el.style.position = "relative"
                    // el.style.width = "25px"
                    // el.style.height = "25px"
                    const image = document.createElement("img")
                    image.className="national-park-logo"
                    image.src = nationalPark.logo || bryceCanyon
                    image.style.objectFit = "contain"
                    image.style.position = "absolute"
                    image.style.height = "60px"
                    image.style.width = "30px"
                    image.style.top = "-30px"
                    image.style.left = "-15px"
                    image.addEventListener("mouseenter", () => {
                        // el.style.width = "300px"
                        // el.style.height = "300px"
                        image.className = ""
                        image.style.width = "200px"
                        image.style.height = "200px"
                        image.style.top = "-100px"
                        image.style.left = "-100px"
                        image.style.zIndex = "100000"
                        el.style.zIndex = "100000"
                        image.style.filter = "brightness(1.5)"

                    })

                    image.addEventListener("mouseleave", () => {
                        image.style.width = "30px"
                        image.style.height = "60px"
                        image.style.top = "-30px"
                        image.style.left = "-15px"
                        image.style.zIndex = "1000"
                        el.style.zIndex = "1000"
                        if (!hasBeenVisited) {
                            image.style.filter = "brightness(0)"
                        }
                        // el.style.width = "25px"
                        // el.style.height = "25px"
                    })

                    if (!hasBeenVisited) {
                        //     if (nationalPark.grow >= 2) {
                        //         image.setAttribute("height", "90px")
                        //         image.setAttribute("width", "60px")
                        //         image.style.top = "-40px"
                        //     }
                        //     if (nationalPark.grow >= 1) {
                        //         image.setAttribute("height", "60px")
                        //         image.setAttribute("width", "30px")
                        //         image.setAttribute("top", "-30px")
                        //         image.setAttribute("left", "-15px")
                        //     }
                        image.style.zIndex = "1000"
                        // } else {
                        image.style.filter = "brightness(0.25)"
                    }

                    el.appendChild(image)
                    el.addEventListener('click', () => {
                        setSelectedNationalPark(nationalPark.name)
                    })
                    const marker = new mapboxgl.Marker(el)
                        .setLngLat(coordinates)
                        .addTo(map.current);
                    // addListenersToMarker(marker, activityLocation.location)
                    setParkMarkersObj(currentParkMarkersObj => {
                        currentParkMarkersObj[nationalPark.name] = el
                        return currentParkMarkersObj
                    })
                }
            })
        // setLocationMarkersObj(markersObj)
    }

    const updateParkMarkersDisplay = (markersObj, shouldHide) => {
        Object.values(markersObj).forEach(marker => {
            if (shouldHide) {
                marker.style.display = "none"
            } else {
                marker.style.display = "block"
            }
        })
    }


    useEffect(() => {
        if (selectedNationalPark) {
            updateParkMarkersDisplay(parkMarkersObj, true)
        } else {
            updateParkMarkersDisplay(parkMarkersObj, false)
        }
    }, [selectedNationalPark, parkMarkersObj])

    const removeNationalParkLayers = () => {
                const trails = JSON.parse(selectedNationalParkObj?.trails)
                trails?.features?.forEach(trail => {
                    const existingSource = map.current.getLayer(trail.properties.OBJECTID)
                    if (existingSource) {
                        map.current.removeLayer(trail.properties.OBJECTID);
                        map.current.removeSource(trail.properties.OBJECTID);
                    }

                })
        const existingLayer = map.current.getLayer(`${selectedNationalParkObj?.name}-borders`)
        if (existingLayer) {
            map.current.removeLayer(`${selectedNationalParkObj?.name}-borders`)
            map.current.removeSource(selectedNationalParkObj?.name);
        }
    }

    useEffect(() => {
        if (selectedNationalPark) {
            // const nationalParkInfo = nationalParks.find(nationalPark => nationalPark.name === selectedNationalPark)
            axios.get(`${getServerUrl()}/nationalPark/${selectedNationalPark}`, {
            })
                .then(response => {
                    const nationalParkInfo = JSON.parse(JSON.stringify(response.data))
                    setSelectedNationalParkObj(nationalParkInfo)
                    getZoom(nationalParkInfo)
                    const trails = JSON.parse(nationalParkInfo?.trails)
                    trails?.features?.forEach(trail => {
                        const existingSource = map.current.getSource(trail.properties.OBJECTID)
                        if (!existingSource) {
                            map.current.addSource(`${trail.properties.OBJECTID}`, {
                                'type': 'geojson',
                                'data': {
                                    "type": "FeatureCollection",
                                    "features": [trail]
                                }
                            });
                        }
                        map.current.addLayer({
                            'id': `${trail.properties.OBJECTID}`,
                            'type': 'line',
                            'source': `${trail.properties.OBJECTID}`,
                            'layout': {},
                            'paint': {
                                'line-color': hasHikedTrail(trips, trail.properties.TRLNAME, selectedNationalPark) ? "darkorange" : "black",
                                'line-width': 1
                            }
                        });
                    })
                    const boundary = JSON.parse(nationalParkInfo?.boundary)
                    map.current.addSource(nationalParkInfo?.name, {
                        'type': 'geojson',
                        'data': {
                            "type": "FeatureCollection",
                            "features": boundary?.features
                        }
                    });

                    // const colorArray = ['Red', 'White', 'Blue']
                    //
                    // const randomColor = colorArray[Math.floor(Math.random() * 3)]
                    // map.current.addLayer({
                    //     'id': `${nationalParkInfo?.name}-border-fills`,
                    //     'type': 'fill',
                    //     'source': nationalParkInfo?.name,
                    //     'layout': {},
                    //     'paint': {
                    //         'fill-color': [hasVisitedPark] ? 'white' : '#565656',
                    //         'fill-opacity': [
                    //             'case',
                    //             ['boolean', ['feature-state', 'hover'], false],
                    //             1,
                    //             0.2
                    //         ]
                    //     }
                    // });

                    map.current.addLayer({
                        'id': `${nationalParkInfo?.name}-borders`,
                        'type': 'line',
                        'source': nationalParkInfo?.name,
                        'layout': {},
                        'paint': {
                            'line-color': 'black',
                            'line-width': 1
                        }
                    });
                })

        }
    }, [selectedNationalPark])


    useEffect(() => {
        if (trips && trips.length && map.current) {
            if (map.current) {
                // map.current.on('zoomend', (e) => {
                //     setCurrentZoom(currentZoomValue => {
                //         const logos = document.getElementsByClassName("national-park-logo")
                //         const zoom = map.current.getZoom()
                //         for (let i = 0; i < logos.length; i++) {
                //             const logo = logos[i]
                //             const height = logo.style.height.split("px")[0]
                //             const width = logo.style.width.split("px")[0]
                //             // if (zoom > 4.3) {
                //             logo.style.height = (height * zoom / currentZoomValue) + "px"
                //             logo.style.width = (width * zoom / currentZoomValue) + "px"
                //             // }
                //         }
                //         return zoom
                //     })
                //
                //     // event type: boxzoomstart
                // });
                // const markersList = []
                nationalParks?.forEach((nationalParkInfo, index) => {
                    const numParkVisits = trips.filter(trip =>
                        trip.categoryItem === nationalParkInfo.name ||
                        trip.activities?.some(activity => activity.categoryItem === nationalParkInfo.name)
                    ).length
                    const hasVisitedPark = numParkVisits > 0
                    // if (hasVisitedPark) {
                    addMarkerToLocation(nationalParkInfo, hasVisitedPark, index)
                    // }
                    // locations.forEach(location => {
                    //     if (location.state === stateInfo.name) {
                    //         parkHasBeenVisited = true
                    //     }
                    // })
                    // team.Team.toLowerCase().includes(trip.categoryItem.toLowerCase()
                    //     map.current.addSource(nationalParkInfo?.name, {
                    //         'type': 'geojson',
                    //         'data': {
                    //             "type": "FeatureCollection",
                    //             "features": nationalParkInfo.boundary?.features
                    //         }
                    //     });
                    //
                    //     // const colorArray = ['Red', 'White', 'Blue']
                    //     //
                    //     // const randomColor = colorArray[Math.floor(Math.random() * 3)]
                    //     map.current.addLayer({
                    //         'id': `${nationalParkInfo?.name}-border-fills`,
                    //         'type': 'fill',
                    //         'source': nationalParkInfo?.name,
                    //         'layout': {},
                    //         'paint': {
                    //             'fill-color': [hasVisitedPark] ? 'white' : '#565656',
                    //             'fill-opacity': [
                    //                 'case',
                    //                 ['boolean', ['feature-state', 'hover'], false],
                    //                 1,
                    //                 0.2
                    //             ]
                    //         }
                    //     });
                    //
                    // map.current.addLayer({
                    //     'id': `${nationalParkInfo?.name}-borders`,
                    //     'type': 'line',
                    //     'source': nationalParkInfo?.name,
                    //     'layout': {},
                    //     'paint': {
                    //         'line-color': 'black',
                    //         'line-width': 1
                    //     }
                    // });

                    // map.current.on('click', `${stateInfo?.name}state-fills`, (e) => {
                    //     if (stateHasBeenVisited) {
                    //         setOpenTripModal(stateInfo.name);
                    //     }
                    // });
                })

                setTimeout(() => {
                    console.log(map.current?.getZoom())
                    console.log(map.current?.getCenter())
                }, 10000)
            }


            // });
        }
    }, [trips, map.current])

    const returnToFullscreenMap = () => {
        map.current.flyTo({
            center: [-97.1, 37.8],
            duration: 1000,
            animate: true,
            zoom: 4.2
        });
}


useEffect(() => {
    if (map.current) return;
    map.current = new mapboxgl.Map({
        container: mapContainer.current,
        style: 'mapbox://styles/mapbox/streets-v11',
        center: center || [-97.1, 37.8],
        zoom: zoom || 3.5,
    });

    // const zoomArray = [[-68.3421538194792, 44.2537560961911], [-81.7561972637942, 24.5662299741084], [-124.380229122793, 47.6022726842661]]
    // var bounds = zoomArray?.reduce(function (bounds, coord) {
    //     return bounds.extend(coord);
    // }, new mapboxgl.LngLatBounds(zoomArray[0], zoomArray[0]));
    //
    // const latDifference = Math.abs(bounds._ne.lat - bounds._sw.lat)
    // const lngDifference = Math.abs(bounds._ne.lng - bounds._sw.lng)
    //
    // bounds._ne = {
    //     lng: bounds._ne.lng,
    //     lat: bounds._ne.lat + latDifference * 0.15
    // }
    // bounds._sw = {
    //     lng: bounds._sw.lng - lngDifference,
    //     lat: bounds._sw.lat
    // }
    //
    // map.current.fitBounds(bounds, {
    //     padding: 10
    // });
    // Data: UN Human Development Index 2017 Europe extract

// Source: https://ourworldindata.org/human-development-index
    const data = [
        {"code": "CUB"},
        {'code': "BHS"},
        {'code': 'MEX', 'hdi': 0},
        {'code': 'CAN', 'hdi': 0}
    ];

    map.current.on('load', () => {
// Add source for country polygons using the Mapbox Countries tileset
// The polygons contain an ISO 3166 alpha-3 code which can be used to for joining the data
// https://docs.mapbox.com/vector-tiles/reference/mapbox-countries-v1
        map.current.addSource('countries', {
            type: 'vector',
            url: 'mapbox://mapbox.country-boundaries-v1'
        });

// Build a GL match expression that defines the color for every vector tile feature
// Use the ISO 3166-1 alpha 3 code as the lookup key for the country shape
        const matchExpression = ['match', ['get', 'iso_3166_1_alpha_3']];

// Calculate color values for each country based on 'hdi' value
        for (const row of data) {
// Convert the range of data values to a suitable color
            const green = row['hdi'] * 255;
            const color = `rgb(255, 255, 255)`;

            matchExpression.push(row['code'], color);
        }

// Last value is the default, used where there is no data
        matchExpression.push('rgba(0, 0, 0, 0)');


// The mapbox.country-boundaries-v1 tileset includes multiple polygons for some
// countries with disputed borders.  The following expression filters the
// map view to show the "US" perspective of borders for disputed countries.
// Other world views are available, for more details, see the documentation
// on the "worldview" feature property at
// https://docs.mapbox.com/data/tilesets/reference/mapbox-countries-v1/#--polygon---worldview-text
        const WORLDVIEW = "US";
        const worldview_filter = ["all", ["==", ["get", "disputed"], "false"], ["any", ["==", "all", ["get", "worldview"]], ["in", WORLDVIEW, ["get", "worldview"]]]];

// Add layer from the vector tile source to create the choropleth
// Insert it below the 'admin-1-boundary-bg' layer in the style
        map.current.addLayer(
            {
                'id': 'countries-join',
                'type': 'fill',
                'source': 'countries',
                'source-layer': 'country_boundaries',
                'paint': {
                    'fill-color': matchExpression
                },
                'filter': worldview_filter
            },
            'admin-1-boundary-bg'
        );
    });

});

return (
    <div id='fullScreenMap'>
        {selectedNationalPark && (
            <button
                className="ui button"
                id="exit-national-park"
                type='button'
                onClick={() => {
                    removeNationalParkLayers(selectedNationalPark)
                    setSelectedNationalParkObj(null)
                    setSelectedNationalPark(null)
                    returnToFullscreenMap()
                }}
            >
                Exit
            </button>
        )}
        <div ref={mapContainer} className="map-container-fullscreen"/>
    </div>
);
}

export default NationalParksMapTwo;